import { EHumanReviewTab } from './human-review-requests.type'
import { isEnumValue } from './human-review-search-params.util'

// Visible tabs depend on the project: the memory is per project
const getStorageKey = (projectId: number) => `humanReview_lastTab_${projectId}`

export const getLastTab = (projectId: number): EHumanReviewTab | null => {
  const storedTab = localStorage.getItem(getStorageKey(projectId))
  return storedTab !== null && isEnumValue(EHumanReviewTab, storedTab) ? storedTab : null
}

export const setLastTab = (projectId: number, tab: EHumanReviewTab) => {
  localStorage.setItem(getStorageKey(projectId), tab)
}
